export default __webpack_public_path__ + "static/media/contact-image.8f7c97ef.svg";